
import React from 'react'
import withFormState from 'src/components/aciacehighway/hocs/withFormState';
import { CreateEntrySummary } from '../component/entry-form';
import { ScopedCssBaseline } from '@mui/material';

// const fullTitle = 'Create Entry Summary';
// const shortTitle = 'Create';
// const BCrumb = [
//   { title: "ABI" },
//   { title: "Entry Summary", to: pathMap.ABI_ENTRY_SUMMARY_LIST_VIEW },
//   { title: shortTitle, },
// ];


function AddPage({ history }) {
  return (<ScopedCssBaseline>
    <CreateEntrySummary history={history} />
  </ScopedCssBaseline>);
}

export default withFormState(AddPage)
